import { render, staticRenderFns } from "./CategoryMainOld.vue?vue&type=template&id=6182b704&scoped=true"
import script from "./CategoryMainOld.vue?vue&type=script&lang=js"
export * from "./CategoryMainOld.vue?vue&type=script&lang=js"
import style0 from "./CategoryMainOld.vue?vue&type=style&index=0&id=6182b704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6182b704",
  null
  
)

export default component.exports